import React, { useContext, useState } from "react";
import Banner from "../../../Utils/Banner/Banner";
import MobileField from "../../../Utils/BasicComponents/MobileField";
import { useNavigate } from "react-router-dom";
import AuthBtn from "../../../Utils/AuthBtn/AuthBtn";
import { AuthContext } from "../../../services/AuthProvider";

export default function CreatePassword() {
  const { handleChangePassword } = useContext(AuthContext);
  const [createPswd, setCreatePswd] = useState("");
  const [createConfPswd, setCreateConfPswd] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const createNewPswd = async () => {
    setErrorMsg("");
    if (createPswd === createConfPswd) {
      // if new paswd created take to the login
      await handleChangePassword(createConfPswd)
        .then(() => navigate("/login"))
        .catch((err) => console.log("err", err));
    } else {
      setErrorMsg("Passwords Does not match");
      return;
    }
  };

  return (
    <section className="w-full h-full">
      <Banner heading={"Earn higher per hour"} />
      <MobileField
        uniqueId="ConfigurePswd"
        textField="Create Password"
        createPswd={createPswd}
        setCreatePswd={setCreatePswd}
      />
      <MobileField
        textField="Confirm Password"
        createPswd={createConfPswd}
        setCreatePswd={setCreateConfPswd}
        errorMsg={errorMsg}
      />
      <AuthBtn clickFunction={createNewPswd} />
    </section>
  );
}
